const Common = {
  All: "ALL",
};

export default Object.freeze(Common);
